import { render } from "./AssignmentDetail.vue?vue&type=template&id=20291cd3"
import script from "./AssignmentDetail.vue?vue&type=script&lang=js"
export * from "./AssignmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__